import { render, staticRenderFns } from "./Samhallet.vue?vue&type=template&id=08782952&"
import script from "./Samhallet.vue?vue&type=script&lang=js&"
export * from "./Samhallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports